import styled from "styled-components";

export const DescriptionLimiter = styled.span`
  display: inline-block;

  ${props => props.theme.breakpointsV2.smallTablet} {
    width: 65%;
  }
`;
